<template>
  <div class="viewPage">
    <div class="boxHeader">
      <h3 style="font-weight: bold">개인정보 수집 및 이용약관</h3>
    </div>
    <div class="card">
      <div>(주)헥토이노베이션에서는 원활한 상담을 위하여 다음과 같이 고객님의 개인정보를 처리 합니다.</div>

      <ul class="lineAligns">
        <li>이용 목적 : 회원 식별/상담 등 원활한 상담을 위한 정보 활용</li>
        <li>수집 항목 : 휴대폰 번호</li>
        <li>보유 기간 : 고객 상담 완료 이후 12개월 혹은 법정 보유기간</li>
        <li>수탁 업체 : 더화이트커뮤니케이션(주)</li>
        <li>위탁 업체 : (주)헥토이노베이션</li>
        <li>위탁 업무 : 채팅 기반 상담 서비스 제공</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customer_authentication_notice_for_hecto'
};
</script>
<style lang="scss">
#app {
  margin: 0 0;
  width: 100%;
}

.viewPage {
  .boxHeader {
    width: 100%;
    height: 55px;
    background-color: #f8f153;
    display: inline-flex;
    align-items: center;
    padding-left: 1.23em;

    h3 {
      font-size: 1.375rem;
      font-family: inherit;
      line-height: 1.2;
    }
  }

  .card {
    margin: 16px;
    border: 1 #000 solid;

    display: block;
    border-radius: 2px;
    min-width: 0;
    position: relative;
    text-decoration: none;
    box-shadow: 0 3px 9px 3px #dee0f57a;
    padding: 13px;
    border: 1px solid #e8ebed;
    border-radius: 5px;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.87);

    .lineAligns {
      margin-top: 5px;
      padding-left: 1.89em;
      line-height: 2.53;
      font-size: 13px;

      li::marker {
        content: '-';
      }
    }
  }
}
</style>
